
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewellery/category/[category]",
      function () {
        return require("private-next-pages/jewellery/category/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jewellery/category/[category]"])
      });
    }
  